import Phaser from 'phaser';
import { BootScene } from '../scenes/BootScene';
import { TitleScene } from '../scenes/TitleScene';
import { MenuScene } from '../scenes/MenuScene';
import { SelectionScene } from '../scenes/SelectionScene';
import { ArenaSelectScene } from '../scenes/ArenaSelectScene';
import { BattleScene } from '../scenes/BattleScene';
import { TorneoResultsScene } from '../scenes/TorneoResultsScene';

export const GAME_CONFIG: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: 1280,
  height: 720,
  parent: document.body,
  backgroundColor: '#000000',
  physics: {
    default: 'matter',
    matter: {
      gravity: { x: 0, y: 0 },
      debug: false,
      enableSleeping: false,
    },
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  scene: [BootScene, TitleScene, MenuScene, SelectionScene, ArenaSelectScene, BattleScene, TorneoResultsScene],
};
